import { CROSS_SELL_SKY_BET_URL } from '../config';

export const BET = 'bet';

export const ssoMap = {
    [BET]: CROSS_SELL_SKY_BET_URL
};

export const dcmpTags = {
    mastHead: 'ITV7_Sweeps_Masthead',
    selection: 'ITV7_Sweeps_Selection',
    promo: 'ITV7_Sweeps_Promo',
    other: 'ITV7_Sweeps_Other'
};

export const affIds = {
    masthead: '1197330257',
    selection: '1197330258',
    promo: '1197330259',
    other: '1197330260'
};

export const buildTransferLink = ({ to, dcmp, affId, event, isLoggedIn }) => {
    const map = ssoMap;

    if (!map[to]) {
        return null;
    }

    let path = '';
    if (event) {
        path += event;
    }

    path += `?islggdn=${isLoggedIn}`;

    if (dcmp && affId) {
        path += `&dcmp=${dcmp}&AFF_ID=${affId}`;
    }

    return `${map[to]}${path}`;
};
